export enum Permission {
    Admin = 'extension_role_admin',
    JobExchange = 'extension_role_job_exchange',
    TrainingManager = 'extension_role_training_manager',
    TrainingManagerBudgets = 'extension_role_training_manager_budgets',
    VCA = 'extension_role_vca',
    VCABudgets = 'extension_role_vca_budgets'
}
